import axios from 'axios'

//export const API_URL = "https://www.devbackendspace.site:8082/";
export const API_URL = "https://www.apilados.site/";

const instance = axios.create({
    withCredentials: false,
    baseURL: API_URL,
    headers: {
        'Authorization': localStorage.getItem("token"),
        'Content-Type': 'application/json'
    }
})

export default instance
